import { Utils } from '../../Core';
import { listPartnerTypeApi as API } from '../../Apis';
import { mocksService } from './ListPartnerType.mocks';
import dataFields from '../../Types/ListPartnerType.json';
import { ListPartnerTypeTypes } from '../../Types';

const invokeApiFunction = async (
  params?: ListPartnerTypeTypes.ListPartnerTypeRequestType,
) => {
  const defaultLanguage = 'pt_br';
  return API.call.get(params?.language ?? defaultLanguage);
};

const handleSucessFinalResponseFunction = (
  data: ListPartnerTypeTypes.ListPartnerTypeRawDataType,
): ListPartnerTypeTypes.ListPartnerTypeDataType[] => {
  return data.ValueByTypeList.map((valueByType) => {
    const obj: ListPartnerTypeTypes.ListPartnerTypeDataType = {
      name: valueByType.name,
      value: valueByType.value,
      id: valueByType.value
        .replace(/\s/g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]|[^\w\d]/g, '')
        .toUpperCase(),
    };
    if (valueByType.description) {
      obj.description = valueByType.description;
    }

    return obj;
  });
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction,
  definitionsAPI: API.definitions,
  mocksService,
  dataFields,
  handleResponse: {
    handleSucessFinalResponseFunction,
  },
});
